import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Parallax au scroll via data-parallax="0.1" (vitesse, négatif pour inverser).
 * data-parallax-fit : ajoute un scale pour couvrir le déplacement
 * (à utiliser sur les images dans un conteneur overflow hidden).
 */
const MOBILE_BREAKPOINT = 1000;

export default class Parallax {
	constructor() {
		this.items = [...document.querySelectorAll("[data-parallax]")];
		if (!this.items.length || window.innerWidth < MOBILE_BREAKPOINT) return;

		this.triggers = this.items.map((el) => {
			const speed = parseFloat(el.dataset.parallax) || 0.1;
			const amount = speed * 100;

			if (el.hasAttribute("data-parallax-fit")) {
				gsap.set(el, { scale: 1 + Math.abs(speed) * 2 });
			}

			const tween = gsap.fromTo(
				el,
				{ yPercent: -amount },
				{
					yPercent: amount,
					ease: "none",
					scrollTrigger: {
						trigger: el.closest("section") || el.parentElement,
						start: "clamp(top bottom)",
						end: "clamp(bottom top)",
						scrub: true,
					},
				}
			);

			return tween.scrollTrigger;
		});
	}

	destroy() {
		this.triggers?.forEach((trigger) => trigger?.kill());
	}
}
